import { default as _matchAll } from 'string.prototype.matchall';

export default function matchAll(value: string, regExp: RegExp)
{
    return _matchAll(value, regExp);
}
